import Clipboard from 'clipboard'
import {
  Message
} from 'element-ui'
export default {
  inserted(el, binding, vnode) {
    el.addEventListener('click', (event) => {
      // console.log(binding.value)
      let id = binding.value ? '#' + binding.value : '#copy'
      let clipborad = new Clipboard(id)
      // 复制成功
      clipborad.on('success', function () {
        // Message({
        //   message: '复制成功！',
        //   type: 'success'
        // })
        // 释放内存，如果缺少，复制成功的提示会一直累加
        clipborad.destroy()
      })
      // 复制失败
      clipborad.on('error', function () {
        // Message({
        //   message: '复制失败！',
        //   type: 'error'
        // })
        // 释放内存
        clipborad.destroy()
      })
    }, false)
  }
}



// WEBPACK FOOTER //
// ./src/directive/operate/copy.js